import { render, staticRenderFns } from "./RowBlockInsuranceCommissionDgo.vue?vue&type=template&id=f35c2a08&"
import script from "./RowBlockInsuranceCommissionDgo.vue?vue&type=script&lang=js&"
export * from "./RowBlockInsuranceCommissionDgo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports